import { useEffect } from 'react'
import { useParams } from 'react-router-dom'
import { PAGE_LINKS } from '@/helpers/commonConsts'
import { commonUtils } from '@/helpers/commonUtils'

const CourseShareRedirect = (): null => {
  const { goodsId, goodsType, resourceId, check } = useParams<
    'goodsId' | 'goodsType' | 'resourceId' | 'check'
  >()

  useEffect((): void => {
    if (!goodsId || !goodsType || !resourceId || !check) {
      window.location.replace(window.location.origin)
      return
    }

    if (commonUtils.isMobile()) {
      const mobileUrl = new URL(PAGE_LINKS.buyRecommend, window.location.origin)
      mobileUrl.searchParams.set('goodsId', goodsId)
      mobileUrl.searchParams.set('goodsType', goodsType)
      mobileUrl.searchParams.set('resourceId', resourceId)
      mobileUrl.searchParams.set('check', check)
      window.location.replace(mobileUrl.toString())
      return
    }

    const pcParams = [goodsId, goodsType, resourceId]
      .map((segment) => encodeURIComponent(segment))
      .join('/')
    const pcPath = `${PAGE_LINKS.pcGoodsDetail}/pinyin/${pcParams}`
    window.location.replace(`${window.location.origin}${pcPath}`)
  }, [check, goodsId, goodsType, resourceId])

  return null
}

export default CourseShareRedirect
